var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNotFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 104,
    viewBox: "0 0 118 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9712 81.6C59.5125 81.6 59.9512 81.1612 59.9512 80.62C59.9512 80.0788 59.5125 79.64 58.9712 79.64C58.43 79.64 57.9912 80.0788 57.9912 80.62C57.9912 81.1612 58.43 81.6 58.9712 81.6Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5012 7.82001V12.12",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3413 9.97003H32.6513",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 34.94C71.0812 34.94 62.5612 34.6 54.5912 32.38C46.7712 30.21 39.5912 26 33.1912 21.13C29.0012 17.96 25.1912 15.43 19.7512 15.81C14.4293 16.098 9.34 18.0854 5.23121 21.48C-1.68879 27.54 -0.648793 38.77 2.12121 46.63C6.28121 58.5 18.9412 66.77 29.7012 72.12C42.1312 78.33 55.7912 81.94 69.4812 84.01C81.4812 85.84 96.9012 87.16 107.301 79.33C116.851 72.12 119.471 55.68 117.131 44.58C116.563 41.3009 114.817 38.3421 112.221 36.26C105.511 31.35 95.5012 34.63 87.9612 34.79C85.1612 34.85 82.3112 34.92 79.4512 34.94Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9112 1.96C66.4524 1.96 66.8912 1.52124 66.8912 0.98C66.8912 0.43876 66.4524 0 65.9112 0C65.3699 0 64.9312 0.43876 64.9312 0.98C64.9312 1.52124 65.3699 1.96 65.9112 1.96Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9912 78.27V82.57",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8413 80.42H17.1413",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3714 103.47C79.6458 103.47 96.0814 102.445 96.0814 101.18C96.0814 99.9153 79.6458 98.89 59.3714 98.89C39.097 98.89 22.6614 99.9153 22.6614 101.18C22.6614 102.445 39.097 103.47 59.3714 103.47Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8811 76.65H25.4712C25.0468 76.6497 24.6276 76.5572 24.2425 76.379C23.8574 76.2007 23.5156 75.9409 23.2407 75.6176C22.9659 75.2943 22.7646 74.9151 22.6507 74.5063C22.5368 74.0975 22.5131 73.6689 22.5812 73.25L30.6912 24.07C30.8007 23.3855 31.151 22.7627 31.679 22.3135C32.207 21.8644 32.878 21.6184 33.5712 21.62H96.9812C97.4052 21.62 97.8242 21.7124 98.2089 21.8908C98.5936 22.0691 98.9349 22.3291 99.209 22.6527C99.4831 22.9762 99.6834 23.3556 99.796 23.7645C99.9086 24.1733 99.9309 24.6017 99.8612 25.02L91.7912 74.2C91.6789 74.8887 91.3237 75.5145 90.7898 75.9639C90.256 76.4133 89.5789 76.6567 88.8811 76.65Z",
    fill: "#D2D2D2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6625 20.3339L52.0238 3.52876C50.9143 3.0334 49.6133 3.53123 49.118 4.6407L37.1889 31.3586C36.6935 32.468 37.1913 33.769 38.3008 34.2643L75.9396 51.0695C77.049 51.5648 78.35 51.067 78.8454 49.9575L90.7745 23.2397C91.2698 22.1302 90.772 20.8292 89.6625 20.3339Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6013 76.63H24.8813C24.1059 76.6274 23.3632 76.3175 22.8159 75.7683C22.2686 75.2191 21.9613 74.4754 21.9613 73.7V28.77C21.952 28.3802 22.0205 27.9925 22.163 27.6296C22.3054 27.2666 22.5189 26.9358 22.7908 26.6564C23.0628 26.377 23.3877 26.1547 23.7467 26.0025C24.1057 25.8503 24.4914 25.7712 24.8813 25.77H48.0913C48.6299 25.772 49.1575 25.9224 49.6161 26.2046C50.0748 26.4869 50.4468 26.8901 50.6913 27.37L54.0013 33.85C54.2449 34.3306 54.6167 34.7345 55.0755 35.0169C55.5344 35.2993 56.0625 35.4492 56.6013 35.45H88.6013C89.3757 35.45 90.1184 35.7577 90.666 36.3053C91.2136 36.8529 91.5213 37.5956 91.5213 38.37V73.7C91.5213 74.4754 91.214 75.2191 90.6666 75.7683C90.1193 76.3175 89.3766 76.6274 88.6013 76.63Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7912 36.98C75.11 36.9781 71.511 38.0678 68.4493 40.1115C65.3875 42.1552 63.0007 45.061 61.5906 48.4614C60.1805 51.8617 59.8106 55.6039 60.5275 59.2145C61.2445 62.8252 63.0161 66.1421 65.6184 68.7458C68.2206 71.3494 71.5366 73.1228 75.1468 73.8417C78.7571 74.5606 82.4995 74.1926 85.9006 72.7844C89.3017 71.3761 92.2088 68.9909 94.2541 65.9302C96.2994 62.8696 97.3912 59.2712 97.3912 55.59C97.3912 50.6561 95.4318 45.9241 91.9439 42.4343C88.4561 38.9446 83.7251 36.9827 78.7912 36.98Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0312 69.09L96.9912 74.05",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4306 71.6401L94.8896 73.2521C94.1989 73.9747 94.2247 75.1204 94.9473 75.8111L108.32 88.5948C109.043 89.2856 110.188 89.2598 110.879 88.5372L112.42 86.9252C113.111 86.2027 113.085 85.0569 112.362 84.3662L98.9897 71.5825C98.2671 70.8917 97.1213 70.9175 96.4306 71.6401Z",
    fill: "#D2D2D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.331 0.980042V5.29004",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.171 3.14001H108.481",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNotFound);
export default __webpack_public_path__ + "static/media/empty-state-not-found.03d855771cd93471c4db3b1b24c32f8b.svg";
export { ForwardRef as ReactComponent };